// src/components/layouts/app/header/desktop/SearchBarDesktop.tsx
import React, { useState } from 'react';
import { Search } from 'lucide-react';

interface SearchBarDesktopProps {
  onSearch?: (query: string) => void;
  suggestions?: string[];
  placeholder?: string;
}

const defaultSuggestions = ['MacBook Pro', 'PC Dell', 'Clavier mécanique', 'Souris gaming'];

export const SearchBarDesktop: React.FC<SearchBarDesktopProps> = ({
  onSearch,
  suggestions = defaultSuggestions,
  placeholder = "Rechercher un produit...",
}) => {
  const [searchValue, setSearchValue] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);

  const handleSearchFocus = () => setShowSuggestions(true);
  const handleSearchBlur = () => setTimeout(() => setShowSuggestions(false), 200);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && searchValue.trim()) {
      onSearch?.(searchValue);
      setShowSuggestions(false);
    }
  };

  const handleSuggestionClick = (suggestion: string) => {
    setSearchValue(suggestion);
    onSearch?.(suggestion);
    setShowSuggestions(false);
  };

  const filteredSuggestions = suggestions.filter(s =>
    s.toLowerCase().includes(searchValue.toLowerCase())
  );

  return (
    <div className="relative">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
        <input
          type="text"
          placeholder={placeholder}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onFocus={handleSearchFocus}
          onBlur={handleSearchBlur}
          onKeyDown={handleKeyDown}
          className="w-80 pl-9 pr-4 py-1.5 text-sm text-black border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition-all"
        />
      </div>
      {showSuggestions && searchValue && filteredSuggestions.length > 0 && (
        <div className="absolute top-full left-0 mt-2 w-80 bg-white border border-gray-200 rounded-xl shadow-lg z-20 overflow-hidden">
          <ul className="py-2">
            {filteredSuggestions.map((s, idx) => (
              <li key={idx}>
                <button
                  onMouseDown={(e) => e.preventDefault()} // éviter le blur avant click
                  onClick={() => handleSuggestionClick(s)}
                  className="w-full text-left px-4 py-2 text-sm text-black hover:bg-gray-100 flex items-center gap-2"
                >
                  <Search className="w-3.5 h-3.5 text-gray-500" />
                  {s}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};